export default __webpack_public_path__ + "static/media/parlantes.be7c9ad7.jpg";